import React from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { Home } from 'lucide-react';

const linkStyle = { color: '#00d4ff', textDecoration: 'underline' };

const PAGE_TITLE = {
  en: 'LEGAL NOTICES - WORKBIFLOW',
  fr: 'MENTIONS LÉGALES - WORKBIFLOW'
};

const CONTENT = {
  en: [
    { title: '1. Platform Publisher', body: [
      'Company name: PEAK PERFORMANCE PARTNER',
      'Legal form: SUARL (Single-Member Limited Liability Company)',
      'Share capital: 1,000,000 FCFA',
      'Registered office: 16 Rue Jules Ferry, DAKAR Plateau, P.O. Box 2281, DAKAR, Senegal',
      'RCCM (Trade Register): SN.DKR.2025.B.6933',
      'NINEA: 011930535 2A2',
      'Business sector: Organizational and management consulting / Software publishing (WORKBIFLOW)',
      'Note: WORKBIFLOW is software published by PEAK PERFORMANCE PARTNER'
    ]},
    { title: '2. Publication Director', body: [
      'Name: Samba FAYE',
      'Position: CEO (Chief Executive Officer)'
    ]},
    { title: '3. Hosting', body: [
      'The Platform is hosted by:',
      'Host: Supabase Inc.',
      'Address: 970 Toa Payoh North, #07-04, Singapore 318992',
      'Website: https://supabase.com',
      'Certifications: SOC 2 Type II, ISO 27001, GDPR Compliance',
      'Note: Data is hosted on secure cloud servers compliant with GDPR.'
    ]},
    { title: '4. Contact', body: [
      'For any questions or complaints regarding the Platform, you can contact us:',
      'By email: contact@peak-performance-partner.com',
      'By phone: +221 77 150 56 59',
      'By mail: PEAK PERFORMANCE PARTNER, 16 Rue Jules Ferry, DAKAR Plateau, P.O. Box 2281, DAKAR, Senegal',
      'Focal point (for personal data requests):',
      '• Name: Samba FAYE',
      '• Position: CEO',
      '• Email: contact@peak-performance-partner.com',
      '• Phone: +221 77 150 56 59'
    ]},
    { title: '5. Intellectual Property', body: [
      'All elements of the Platform (texts, images, videos, logos, graphics, icons, etc.) are the exclusive property of PEAK PERFORMANCE PARTNER, unless otherwise stated.',
      'The WORKBIFLOW software and its brand are the property of PEAK PERFORMANCE PARTNER.',
      'Any reproduction, representation, modification, publication or adaptation of all or part of the Platform elements is strictly prohibited without prior written authorization from PEAK PERFORMANCE PARTNER.'
    ]},
    { title: '6. Personal Data Protection', body: [
      'In accordance with Law No. 2008-12 of January 25, 2008 on the protection of personal data in Senegal and the General Data Protection Regulation (GDPR), you have the right to access, rectify, delete and object to personal data concerning you.',
      'Response time: Maximum 15 days for the right of access, maximum 30 days for rectification and deletion.',
      'Methods for exercising rights:',
      '• By email: contact@peak-performance-partner.com',
      '• By mail: PEAK PERFORMANCE PARTNER, 16 Rue Jules Ferry, DAKAR Plateau, P.O. Box 2281, DAKAR, Senegal',
      '• Via the website: Legal notices and Terms and conditions of use',
      '• Online access via the user dashboard',
      <>For more information on the processing of your personal data, please consult our <a href="/confidentialite" style={linkStyle}>Privacy Policy</a> and our authorization request form submitted to the Personal Data Commission (CDP) of Senegal.</>,
      'Supervisory authority: Personal Data Commission (CDP) of Senegal',
      '• Address: 76, Mermoz Pyrotechnie, VDN-DAKAR, P.O. Box 25528 Dakar, Fann',
      '• Website: www.cdp.sn',
      '• Email: contact.cdp@cdp.sn',
      '• Phone: +221 33 859 70 30'
    ]},
    { title: '7. Mediation', body: [
      'In accordance with Senegalese legislation in force, in case of dispute, you can contact: Personal Data Commission (CDP) of Senegal',
      '• Address: 76, Mermoz Pyrotechnie, VDN-DAKAR, P.O. Box 25528 Dakar, Fann',
      '• Website: www.cdp.sn',
      '• Email: contact.cdp@cdp.sn',
      '• Phone: +221 33 859 70 30'
    ]},
    { title: '8. Applicable Law and Competent Jurisdiction', body: [
      'These legal notices are governed by Senegalese law.',
      'In case of dispute and in the absence of an amicable agreement, the dispute will be brought before the competent Senegalese courts, in accordance with the rules of jurisdiction in force in Senegal.'
    ]},
    { title: '9. Additional Information', body: [
      'Company creation date: January 29, 2025',
      'Processing implementation date: February 19, 2026',
      'Published software: WORKBIFLOW - Human resources management and time tracking system',
      'Current version: V.2'
    ]}
  ],
  fr: [
    { title: '1. Éditeur de la Plateforme', body: [
      'Raison sociale : PEAK PERFORMANCE PARTNER',
      'Forme juridique : SUARL (Société Unipersonnelle à Responsabilité Limitée)',
      'Capital social : 1 000 000 FCFA',
      'Siège social : 16 Rue Jules Ferry, DAKAR Plateau, BP 2281, DAKAR, Sénégal',
      'RC (Registre de Commerce) : SN.DKR.2025.B.6933',
      'NINEA : 011930535 2A2',
      "Secteur d'activité : Conseil en organisation et en management / Édition de logiciels (WORKBIFLOW)",
      'Note : WORKBIFLOW est un logiciel édité par PEAK PERFORMANCE PARTNER'
    ]},
    { title: '2. Directeur de la publication', body: [
      'Nom : Samba FAYE',
      'Fonction : CEO (Directeur Général)'
    ]},
    { title: '3. Hébergement', body: [
      'La Plateforme est hébergée par :',
      'Hébergeur : Supabase Inc.',
      'Adresse : 970 Toa Payoh North, #07-04, Singapore 318992',
      'Site web : https://supabase.com',
      'Certifications : SOC 2 Type II, ISO 27001, Conformité RGPD',
      'Note : Les données sont hébergées sur des serveurs cloud sécurisés conformes au RGPD.'
    ]},
    { title: '4. Contact', body: [
      'Pour toute question ou réclamation concernant la Plateforme, vous pouvez nous contacter :',
      'Par email : contact@peak-performance-partner.com',
      'Par téléphone : +221 77 150 56 59',
      'Par courrier : PEAK PERFORMANCE PARTNER, 16 Rue Jules Ferry, DAKAR Plateau, BP 2281, DAKAR, Sénégal',
      'Point focal (pour les demandes relatives aux données personnelles) :',
      '• Nom : Samba FAYE',
      '• Fonction : CEO',
      '• Email : contact@peak-performance-partner.com',
      '• Tél : +221 77 150 56 59'
    ]},
    { title: '5. Propriété intellectuelle', body: [
      "L'ensemble des éléments de la Plateforme (textes, images, vidéos, logos, graphismes, icônes, etc.) sont la propriété exclusive de PEAK PERFORMANCE PARTNER, sauf mention contraire.",
      'Le logiciel WORKBIFLOW et sa marque sont la propriété de PEAK PERFORMANCE PARTNER.',
      'Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments de la Plateforme est strictement interdite sans autorisation écrite préalable de PEAK PERFORMANCE PARTNER.'
    ]},
    { title: '6. Protection des données personnelles', body: [
      "Conformément à la loi n°2008-12 du 25 janvier 2008 portant sur la protection des données à caractère personnel du Sénégal et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.",
      'Délai de réponse : 15 jours maximum pour le droit d\'accès, 30 jours maximum pour la rectification et la suppression.',
      'Modalités d\'exercice des droits :',
      '• Par email : contact@peak-performance-partner.com',
      '• Par courrier : PEAK PERFORMANCE PARTNER, 16 Rue Jules Ferry, DAKAR Plateau, BP 2281, DAKAR, Sénégal',
      '• Via le site Internet : Mentions légales et Conditions générales d\'utilisation',
      '• Accès en ligne via le tableau de bord utilisateur',
      <>Pour plus d'informations sur le traitement de vos données personnelles, consultez notre <a href="/confidentialite" style={linkStyle}>Politique de Confidentialité</a> et notre formulaire de demande d'autorisation déposé auprès de la Commission des Données Personnelles (CDP) du Sénégal.</>,
      'Autorité de contrôle : Commission des Données Personnelles (CDP) du Sénégal',
      '• Adresse : 76, Mermoz Pyrotechnie, VDN-DAKAR, BP : 25528 Dakar, Fann',
      '• Site web : www.cdp.sn',
      '• Email : contact.cdp@cdp.sn',
      '• Tél : +221 33 859 70 30'
    ]},
    { title: '7. Médiation', body: [
      'Conformément à la législation sénégalaise en vigueur, en cas de litige, vous pouvez contacter : Commission des Données Personnelles (CDP) du Sénégal',
      '• Adresse : 76, Mermoz Pyrotechnie, VDN-DAKAR, BP : 25528 Dakar, Fann',
      '• Site web : www.cdp.sn',
      '• Email : contact.cdp@cdp.sn',
      '• Tél : +221 33 859 70 30'
    ]},
    { title: '8. Droit applicable et juridiction compétente', body: [
      'Les présentes mentions légales sont régies par le droit sénégalais.',
      'En cas de litige et à défaut d\'accord amiable, le litige sera porté devant les tribunaux sénégalais compétents, conformément aux règles de compétence en vigueur au Sénégal.'
    ]},
    { title: '9. Informations complémentaires', body: [
      'Date de création de la société : 29/01/2025',
      'Date de mise en œuvre du traitement : 19/02/2026',
      'Logiciel édité : WORKBIFLOW - Système de gestion des ressources humaines et de pointage',
      'Version actuelle : V.2'
    ]}
  ]
};

const LegalNoticePage = () => {
  const { t, language } = useTranslation();
  const sections = CONTENT[language] || CONTENT.fr;
  const pageTitle = PAGE_TITLE[language] || PAGE_TITLE.fr;

  const pageBg = 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      minWidth: '100vw',
      minHeight: '100vh',
      background: pageBg,
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      overflow: 'auto'
    }}>
      <div style={{
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        background: 'rgba(10, 14, 39, 0.98)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        padding: '12px 12px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px'
      }}>
        <button
          onClick={() => window.location.href = '/'}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: '#ffffff',
            padding: '10px 16px',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          <Home size={18} />
          {t('common.back_to_home')}
        </button>
      </div>

      <div style={{
        width: '100%',
        maxWidth: '100%',
        padding: '20px 16px 40px',
        margin: 0,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '900px',
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          borderRadius: '20px',
          padding: '40px 32px 48px',
          color: 'rgba(255, 255, 255, 0.92)',
          lineHeight: 1.8,
          fontSize: '16px',
          boxSizing: 'border-box',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
        }}>
          <h1 style={{
            fontSize: 'clamp(18px, 2.8vw, 26px)',
            fontWeight: 800,
            margin: '0 0 32px 0',
            color: '#fff',
            textAlign: 'center'
          }}>
            {pageTitle}
          </h1>
          {sections.map((sec, i) => (
            <section key={i} style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
                {sec.title}
              </h2>
              <div>
                {sec.body.map((para, j) => (
                  <p key={j} style={{ marginBottom: '12px', marginTop: 0 }}>
                    {React.isValidElement(para) ? para : para}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;
